import { Checkbox, Modal } from "antd";
import { ALL_COLUMNS, REQUIRED_COLUMNS } from "./constants";

interface Props {
  open: boolean;
  onClose: () => void;
  selectedColumns: string[];
  setSelectedColumns: (cols: string[]) => void;
}

function ColumnSelectorModal({
  open,
  onClose,
  selectedColumns,
  setSelectedColumns,
}: Props) {
  const toggleColumn = (column: string) => {
    if (REQUIRED_COLUMNS.includes(column)) {
      return;
    }

    if (selectedColumns.includes(column)) {
      setSelectedColumns(selectedColumns.filter((c) => c !== column));
    } else {
      setSelectedColumns([...selectedColumns, column]);
    }
  };

  return (
    <Modal title="Select Columns" open={open} onCancel={onClose} footer={null}>
      <Checkbox
        checked={selectedColumns.length === ALL_COLUMNS.length}
        onChange={(e) => {
          if (e.target.checked) {
            setSelectedColumns(ALL_COLUMNS.map((c) => c.key));
          } else {
            setSelectedColumns(REQUIRED_COLUMNS);
          }
        }}
      >
        Select All
      </Checkbox>

      <div className="mt-4 flex flex-col gap-3">
        {ALL_COLUMNS.map((column) => (
          <Checkbox
            disabled={REQUIRED_COLUMNS.includes(column.key)}
            checked={selectedColumns.includes(column.key)}
            onChange={() => toggleColumn(column.key)}
          >
            {column.title}
          </Checkbox>
        ))}
      </div>
    </Modal>
  );
}

export default ColumnSelectorModal;
